module.exports = __webpack_public_path__ + "img/Changyou.18e56886.gif";